import { componentStateStore, consentStore } from '@mfe/store';
import { customElement } from 'lit/decorators.js';

import { TefComsButton } from './TefComsButton';

@customElement('tef-coms-cancel-button')
export class TefComsCancelButton extends TefComsButton {
  variant: string = 'plain';

  override render() {
    return this.getTemplateFn('tefComsCancelButton')(this.variant);
  }

  handleClick() {
    componentStateStore.reset();
    consentStore.actualConsents = structuredClone(consentStore.initialConsents);
  }
}
